import * as React from 'react';
import { compose, pure } from 'recompose';
import { createStyles, withStyles } from '@material-ui/styles';
import { AppBar } from '@material-ui/core/';
const styles = (theme) => createStyles({
    tabsButtonBar: {
        boxShadow: 'inset 0px -8px 10px -10px rgba(0,0,0,0.75)',
    },
});
const TabsHeaderBar = (props) => {
    const { classes, children, testId = 'TabsHeaderBar' } = props;
    return (React.createElement(AppBar, { "data-testid": `${testId}`, classes: { root: classes.tabsButtonBar }, position: "static", color: "default" }, children));
};
const ComposedTabsHeaderBar = compose(withStyles(styles, { withTheme: true }), pure)(TabsHeaderBar);
ComposedTabsHeaderBar.displayName = 'TabsHeaderBar';
export default ComposedTabsHeaderBar;
//# sourceMappingURL=TabsHeaderBar.js.map